import React from 'react';
import styles from './Plans.module.css'; //styles
import Button from '../Button.js'; //styles
import helpers from '../../helpers.js';

import checkIcon from '../../assets/images/check.png'; //styles

const perksTier1 = [
  "Delivery by artic lorry in 2m³ bulk bags",
  "Biochar use planning and tracking through the app",
];

const perksTier2 = [
  "Everything in Individual Purchase",
  "Discounted price per bag",
  "Flexible payment options for repeat customers",
  "Expert support to build your farm’s Biochar Plan",
];

const perksTier3 = [
  "Everything in 1 Year plan",
  "More flexible and priority delivery",
  "Priority access to new features and trials",
  "Multi-year impact monitoring",
  "Custom insights to maximise impact",
];

const renderPerks = (perks) => {
    return perks.map((perk, index) => (
        <div key={index} className={styles.perkRow}>
            <img src={checkIcon} alt="check" className={styles.checkIcon}/>
            <div className={styles.perkText}>
                {perk}
            </div>
        </div>
    ));
};

const Plans = (props) => {
    return(
            <div className={styles.paymentPlansContainer}>
               <div className={styles.paymentPlanContainer}>
                <div className={styles.paymentPlanMainContent}>
                  <div className={styles.paymentPlanNamePrice}>
                    <div className={styles.planName}>
                        INDIVIDUAL PURCHASE
                    </div>
                    <div className={styles.planPrice}>
                        <span className={styles.pricePound}>£</span> 599 <span className={styles.priceDash}> / </span><span className={styles.pricePerTime}> bag </span>
                    </div>
                    </div>
                    <div className={styles.planDescription}>
                      Ideal if you want to target a small area of your farm, or trial biochar before committing to a full plan.
                    </div>
                    <div className={styles.lineSeparator}/>
                    <div className={styles.perksHeader}>
                      Select this option and get:
                    </div>
                    <div className={styles.perksContainer}>
                      {renderPerks(perksTier1)}
                    </div>
                </div>
                 <div className={styles.minOrderAmount}>
                        Min. Order: 2 bags
                </div>
                <Button selected={props.plan === "individual" ? true : false} nameSelected={"Selected"} onPress={() => props.handleChange("plan", "individual")}  customStyle={{width: "80%"}} name={"Select"}/>
                
               </div>
               <div className={styles.recommendedPlanContainer}>
                <div className={styles.recommendedPlanHeader}>
                  Recommended
                </div>
                <div className={helpers.clx(styles.paymentPlanContainer, styles.recommendedPlanContent)}>
                      <div className={styles.paymentPlanNamePrice}>
                          <div className={styles.planName}>
                              1 YEAR
                          </div>
                          <div className={styles.planPrice}>
                              <span className={styles.pricePound}>£</span> 399 <span className={styles.priceDash}> / </span><span className={styles.pricePerTime}> bag </span>
                          </div>
                      </div>
                      <div className={styles.planDescription}>
                       Perfect for farms ready to integrate biochar across larger fields with ongoing support.
                      </div>
                      <div className={styles.lineSeparator}/>
                      <div className={styles.perksHeader}>
                        Select this option and get:
                      </div>
                      <div className={styles.perksContainer}>
                         {renderPerks(perksTier2)}
                      </div>
                      <div className={styles.minOrderAmount}>
                        Min. Order: 12 bags
                      </div>
                      <Button selected={props.plan === "oneYear" ? true : false} nameSelected={"Selected"} onPress={() => props.handleChange("plan", "oneYear")}  customStyle={{width: "80%"}} name={"Select"}/>
                </div>
               </div>
              
               <div className={styles.paymentPlanContainer}>
                    <div className={styles.paymentPlanNamePrice}>
                        <div className={styles.planName}>
                            2 YEARS
                        </div>
                        <div className={styles.planPrice}>
                            <span className={styles.pricePound}>£</span> 399 <span className={styles.priceDash}> / </span><span className={styles.pricePerTime}> bag </span>
                        </div>
                    </div>
                    <div className={styles.planDescription}>
                      Best for long-term soil improvement at scale - our lowest price and biggest impact.
                    </div>
                    <div className={styles.lineSeparator}/>
                    <div className={styles.perksHeader}>
                      Select this option and get:
                    </div>
                    {renderPerks(perksTier3)}
                     <div className={styles.minOrderAmount}>
                        Min. Order: 96 bags
                     </div>
                    <Button selected={props.plan === "twoYears" ? true : false} nameSelected={"Selected"} onPress={() => props.handleChange("plan", "twoYears")}  customStyle={{width: "80%"}} name={"Select"}/>
               </div>
            </div>
    )
}

Plans.defaultProps = {
    selected: ""
  };

export default React.memo(Plans);